import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Div100vh from "react-div-100vh";
import UserRegister from "./components/InitUserPathComponents/UserRegister";
import PickItemPage from "./components/InitUserPathComponents/PickItemPage";
import SpinnerLoader from "../e-learning-homepage/components/views/partial/SpinnerLoader";
import { post } from "../e-learning-display/helper/main";
import SelectGoalPage from "./components/InitUserPathComponents/SelectGoalPage";
import DiagnosticQuestionPage from "./components/InitUserPathComponents/DiagnosticQuestionPage";
import SecondPageComponent from "./components/InitUserPathComponents/SecondPageComponent";
import ThirdPageComponent from "./components/InitUserPathComponents/ThirdPageComponent";
import FinalPageComponent from "./components/InitUserPathComponents/FinalPageComponent";
import LastPageComponent from "./components/InitUserPathComponents/LastPageComponent";
import FourthPageComponent from "./components/InitUserPathComponents/FourthPageComponent";

function InitUserPath() {
  const [isRedirected, setIsRedirected] = useState(false);
  const [page, setPage] = useState(0);
  const [sliderValue, setSliderValue] = useState(0);
  const [userState, setUserState] = useState("register");
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
    passwordRepeat: "",
  });
  const [goals, setGoals] = useState(undefined);
  const [diagnosticQuestions, setDiagnosticQuestions] = useState([]);
  const [selectedGoalId, setSelectedGoalId] = useState(null); // Zamiast tablicy selectedGoalIds, używamy pojedynczej wartości selectedGoalId
  const [ages, setAges] = useState(["18-26", "27-35", "36-48", "49+"]);
  const [selectedAgeIndex, setSelectedAgeIndex] = useState(undefined);
  const [genders, setGenders] = useState(["Mężczyzna", "Kobieta", "Inna"]);
  const [selectedGenderIndex, setSelectedGenderIndex] = useState(undefined);
  const [typeOfJobs, setTypeOfJobs] = useState(["Umysłowa", "Fizyczna"]);
  const [dataFromApp, setDataFromApp] = useState({
    source: "unknown",
    medium: 0,
  });
  const [playerId, setPlayerId] = useState(0);
  const [selectedTypeOfJobIndex, setSelectedTypeOfJobIndex] =
    useState(undefined);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [diagnosticQuestionsTutorial, setDiagnosticQuestionsTutorial] =
    useState(false);

  const newAccountState = window.sessionStorage.getItem("newAccountState");

  if (newAccountState === "loggedIn") {
    window.location.href = "/home/initial-profile";
    return <SpinnerLoader />;
  }

  const registerUser = async () => {
    const preparedAnswersArray = selectedAnswers.reduce((acc, innerArray) => {
      return acc.concat(innerArray);
    }, []);

    await fetch("/demo-registration/demo/register", {
      method: "POST",
      body: JSON.stringify({
        password: userData.password,
        firstName: userData.name,
        email: userData.email,
        goals: [selectedGoalId],
        gamecode: "bloomify",
        quickDemo: 1,
        age: ages[selectedAgeIndex],
        gender: genders[selectedGenderIndex],
        workType: typeOfJobs[selectedTypeOfJobIndex],
        adType: dataFromApp.source,
        accountType: dataFromApp.medium,
        playerId: playerId,
        answers: preparedAnswersArray,
        shareEntityTutorial: false,
        showCheckboxTutorial: false,
        showLightBulbTutorial: false,
        optionalSectionTutorial: false,
        newVideoTutorial: true,
        wantsMoreTutorial: false,
        automaticallyMuted: false,
        courseId: null,
        userSelectedGoalValue: sliderValue,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    // await post("/user/register-form/update", userData);
    window.sessionStorage.setItem("newAccountState", "loggedIn");
    window.location.href = "/home/initial-profile";
  };

  const saveAppEventListener = (event) => {
    const sourceString = event.detail.source;
    const mediumString = event.detail.medium;

    const source = sourceString.slice(sourceString.indexOf("=") + 1);
    const medium = mediumString.slice(mediumString.indexOf("=") + 1);

    const isMediumNaN = isNaN(medium);

    let mediumValue = isMediumNaN ? dataFromApp.medium : +medium;

    if (mediumValue < 0 || mediumValue > 1) {
      mediumValue = 0;
    }

    const dataToSave = {
      source,
      medium: mediumValue,
    };

    setDataFromApp(dataToSave);
    createEmptyPlayer(source);
  };

  const getDiagnosticQuestionComponent = (page) => {
    const indexToShow = page - 4;
    const questionToShow = diagnosticQuestions[indexToShow];

    return (
      <DiagnosticQuestionPage
        page={page}
        setPage={setPage}
        answersToSelect={questionToShow.answers}
        selectedAnswers={selectedAnswers}
        setSelectedAnswers={setSelectedAnswers}
        pageIndex={indexToShow}
        text={questionToShow.text}
        isOptional={questionToShow.optional || false}
        eventName="DIAGNOSTIC_SELECTION"
        playerId={playerId}
        key={questionToShow.id}
      />
    );
  };

  const getMetricQuestionComponent = (page) => {
    const componentsToShow = [
      <PickItemPage
        page={page}
        setPage={setPage}
        items={ages}
        itemIndex={selectedAgeIndex}
        setItemIndex={setSelectedAgeIndex}
        text={"Ile masz lat?"}
        key="ages"
        eventName="AGE_SELECTION"
        playerId={playerId}
      />,
      <PickItemPage
        page={page}
        setPage={setPage}
        items={genders}
        itemIndex={selectedGenderIndex}
        setItemIndex={setSelectedGenderIndex}
        text={"Jaka jest Twoja płeć?"}
        key="genders"
        eventName="SEX_SELECTION"
        playerId={playerId}
      />,
      <PickItemPage
        page={page}
        setPage={setPage}
        items={typeOfJobs}
        itemIndex={selectedTypeOfJobIndex}
        setItemIndex={setSelectedTypeOfJobIndex}
        text={"Jaki jest Twój główny rodzaj wykonywanej pracy?"}
        key="jobs"
        eventName="WORKTYPE_SELECTION"
        playerId={playerId}
      />,
    ];

    const indexToShow = page - 3 - (diagnosticQuestions.length + 1);
    return componentsToShow[indexToShow];
  };

  useEffect(() => {
    if (newAccountState !== "logout") {
      window.sessionStorage.setItem("newAccountState", "init");
    }

    const fetchAllGoals = async () => {
      const response = await fetch("/anon/goals");
      const result = await response.json();
      setGoals(result.data);
    };

    const fetchDiagnosticQuestions = async () => {
      const response = await fetch("/anon/algorithm-settings");
      const result = await response.json();

      const settings = result.data.settings;

      if (!settings || settings.length === 0) return;

      setDiagnosticQuestions(settings);
    };

    fetchAllGoals();
    fetchDiagnosticQuestions();
  }, []);

  const createEmptyPlayer = async (adType) => {
    const response = await post("/anon/create-registration-player", {
      adType,
    });
    const result = await response.json();
    setPlayerId(result.data.id);
  };

  useEffect(() => {
    window.addEventListener(
      "flutterInAppWebViewPlatformReady",
      function (event) {
        window.flutter_inappwebview.callHandler("referrerInformationHandler");
      }
    );

    try {
      window.flutter_inappwebview.callHandler("referrerInformationHandler");
    } catch (err) {
      console.log("error:", err);
    }

    window.addEventListener("referrerInformation", saveAppEventListener);
  }, []);

  if (userState === "register") {
    return (
      <UserRegister
        dataFromApp={dataFromApp}
        setUserState={setUserState}
        userData={userData}
        setUserData={setUserData}
        playerId={playerId}
        setPlayerId={setPlayerId}
        createEmptyPlayer={createEmptyPlayer}
      />
    );
  }

  if (isRedirected || (page === 0 && !goals)) {
    return <SpinnerLoader />;
  }

  if (page === 0) {
    return (
      <PageContainer>
        <SelectGoalPage
          diagnosticQuestionsTutorial={diagnosticQuestionsTutorial}
          setDiagnosticQuestionsTutorial={setDiagnosticQuestionsTutorial}
          page={page}
          setPage={setPage}
          goals={goals}
          selectedGoalId={selectedGoalId}
          setSelectedGoalId={setSelectedGoalId}
          name={userData.name}
          playerId={playerId}
        />
      </PageContainer>
    );
  }
  if (page === 1) {
    return (
      <PageContainer>
        <SecondPageComponent
          page={page}
          setPage={setPage}
          goals={goals}
          selectedGoalId={selectedGoalId}
          userName={userData.name}
          setSliderValue={setSliderValue}
          sliderValue={sliderValue}
          playerId={playerId}
        />
      </PageContainer>
    );
  }

  if (page === 2) {
    return (
      <PageContainer>
        <ThirdPageComponent
          page={page}
          setPage={setPage}
          sliderValue={sliderValue}
        />
      </PageContainer>
    );
  }

  if (page === 3) {
    return (
      <PageContainer>
        <FourthPageComponent page={page} setPage={setPage} />
      </PageContainer>
    );
  }

  if (
    diagnosticQuestions.length > 0 &&
    page - 3 < diagnosticQuestions.length + 1
  ) {
    return (
      <PageContainer>{getDiagnosticQuestionComponent(page)}</PageContainer>
    );
  }

  if (page < 7 + diagnosticQuestions.length) {
    return <PageContainer>{getMetricQuestionComponent(page)}</PageContainer>;
  }

  if (page === 7 + diagnosticQuestions.length) {
    return (
      <PageContainer>
        <FinalPageComponent
          page={page}
          setPage={setPage}
          goals={goals}
          selectedGoalId={selectedGoalId}
          userName={userData.name}
        />
      </PageContainer>
    );
  }

  if (page === 8 + diagnosticQuestions.length) {
    return (
      <PageContainer>
        <LastPageComponent page={page} setPage={setPage} />
      </PageContainer>
    );
  }

  // if (page === 5 + diagnosticQuestions.length) {
  //   return (
  //     <PageContainer>

  //     </PageContainer>
  //   );
  // }

  registerUser();
  return <SpinnerLoader />;
}

export default InitUserPath;

const PageContainer = styled.div`
  background-image: url("/assets/front/img/edustrada/login-bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  min-height: 100%;
  padding: 0 30px;
`;
